import React, { useEffect, useState } from "react";
import { Layout, Sidebar } from "./components";
import styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import api from "../../../../api";
import { useAppSelector } from "../../../../redux/hooks";
import { getHitsState } from "../../../../redux/selectors";
import { IHit } from "../../../../types";
import { Spinner } from "react-bootstrap";
type HitsDetails = {
  id: string;
  detail: string;
};
const DetailsV1 = () => {
  const { id } = useParams<HitsDetails>();
  const [loader, setLoader] = useState<boolean>(true);
  const [detail, setDetail] = useState<IHit>({
    catalog: {
      amount: 1,
      catalogId: 1,
      catalogName: "",
      description: "",
      catalogType: {
        catalogName: "",
        catalogTypeId: 1,
      },
      image: {
        imageId: 1,
        imageName: "",
        imagePath: "",
      },
      price: 1,
    },
    hitProductId: 1,
    registeredTime: "",
  });
  useEffect(() => {
    api.getHit(id).then((data) => setDetail(data));
    setLoader(false);
    console.log(detail);
  }, []);
  useEffect(() => {
    console.log(detail);
  }, [detail]);

  if (loader) return <Spinner />;
  return (
    <div className="container">
      <div className={styles.container}>
        <Sidebar
          imageId={detail.catalog.image.imageId}
          imageName=""
          imagePath={detail.catalog.image.imagePath}
        />
        <Layout
          catalog={detail.catalog}
          hitProductId={detail.hitProductId}
          registeredTime={detail.registeredTime}
        />
      </div>
    </div>
  );
};

export default DetailsV1;
